var _defs, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-gt",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f9f0aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b07e09"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "e",
    cx: 447.4,
    cy: 308.3,
    r: 16.5,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f9f0aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b07e09"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "f",
    cx: 451.6,
    cy: 313,
    r: 10.9,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "g",
    cx: 454.1,
    cy: 308.6,
    r: 9.8,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "h",
    cx: 458.4,
    cy: 307.1,
    r: 17.4,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "k",
    cx: 446,
    cy: 252.4,
    r: 13,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 477.9,
    cy: 215.3,
    r: 0.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#a50a0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c0505"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: 489.1,
    cy: 210.3,
    r: 0.3,
    fx: 489.1,
    fy: 210.3,
    gradientTransform: "scale(.97707 1.02346)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 473.9,
    x2: 472.4,
    y1: 259.2,
    y2: 232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#b07e09",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b07e09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 483.1,
    x2: 485.5,
    y1: 296.7,
    y2: 326.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#b07e09",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b07e09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 451.5,
    x2: 455.4,
    y1: 249.5,
    y2: 240.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f9f0aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b07e09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 473.3,
    x2: 475.9,
    y1: 237.2,
    y2: 270.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f9f0aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b07e09"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4997d0",
    d: "M0 0h512v512H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M170.7 0h170.6v512H170.7Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.7063 0 0 .71942 -83 40.2)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#24420e"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.1 377.5c2.7-.4 4.2-1.2 6-1.8M460.4 371.6a13 13 0 0 1 3 4.7M455.3 371.2a13 13 0 0 1 3 4.2M408.8 238.8c-1 1.6-3 2.7-4.8 3.4M403.7 242c0-1.4-.2-3 0-4.4M401.8 242.6c0 .4.4 1.4.6 2M404.5 245.6l-2 .3M398.5 245c0 2.6.3 5.6.5 7.9M397.2 251.9c.5.8 1 1.5 1.6 1.9M394.2 260.3c.5.9 1 2 1.3 4M399.2 259.6l-2 1.5M398.9 265.5c-1 .9-2.2 1.5-3.5 2.1M391.6 308a16 16 0 0 0 4 4.7M396.2 314.4a8 8 0 0 1-3-1M397.6 321.9l1.7 1M398.9 326.3c1.2.8 2.5 2.3 3.7 3.9M401.2 333c1.4.3 2.5.7 3.2 1M403.4 336.5h2M406.7 331.2l-.5 4.2M407.2 337l.4-1.6M412.3 341.4l-.1 3.2M451.4 372.5l-1.2 1.6M447.8 370.2l-.7-1.8"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M486.1 385a7.8 7.8 0 0 0-3.3-2.7c-7.7-4-15.4-5.9-24-7.3-2.1-.3-4.1-2.2-6.2-3.2-5-2.3-10.5-3.2-15.3-5.7-.3-.1-1.5-.8-2-1.5-2-2.2-5.5-2.9-7.6-5-8.4-7.8-17.2-15-21.8-25.5-5.6-12.7-12.5-25.8-11.6-40.2.6-9.2-.7-18.4 1.5-27 3.4-13 7.6-25.7 15.4-36.4l-1.3.8a103.8 103.8 0 0 0-15.4 36.3c-2.3 8.7-1 18-1.5 27-1 14.5 6 27.6 11.5 40.3 4.6 10.4 13.5 17.7 21.8 25.6 2.2 2 5.6 2.7 7.6 5a10 10 0 0 0 2 1.5c4.9 2.4 10.4 3.3 15.4 5.7 2 1 4 2.8 6 3.2a76.5 76.5 0 0 1 24.2 7.2 8 8 0 0 1 3.3 2.7l1.3-.9"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#67923d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.3 331.6a46.9 46.9 0 0 1-.2-23.5c6.7 13 4.5 23.7.2 23.5zM452.2 377a49 49 0 0 0-21.9 11.4c15.1.1 24-7.3 21.9-11.4zM459.7 372.7a60.1 60.1 0 0 1-14-26.5c15 10.9 18.9 24.3 14 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.6 372.8a55.1 55.1 0 0 1-16-22.8c15.3 8.2 20.3 20.2 16 22.8zM439 366c1-7.8-5.6-24.2-7.5-26-3 16.5 3 27.6 7.5 26zM411.7 341.7a42 42 0 0 1 .5-21c5.5 11.7 3.3 21.2-.5 21zM398 264.9a51 51 0 0 1 21-16c-6.8 14.6-18 19.9-21 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.7 259.3a51.8 51.8 0 0 1 17.4-20c-3.7 15.7-13.7 23.2-17.4 20zM426.6 358.5a55 55 0 0 1-7.3-26.4c11.2 12.5 12 25.3 7.2 26.4zM397.9 322c-7 1.1-21.4-4.6-23-6.3 14.6-3.2 24.4 2 23 6.3zM395.7 312.3c.8-5.5 8.6-15.8 10.3-16.6-1 12-7.4 18.6-10.3 16.6zM447 370.9a57 57 0 0 0-26.1 13.6c18 .1 28.7-8.7 26.1-13.6z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#406325"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.4 331.5c4.2.2 6.4-10.4-.3-23.4a78.9 78.9 0 0 1 .3 23.4zM417.6 351.5a48.8 48.8 0 0 0-21.7-11.2c8.9 12.1 19.9 15.1 21.7 11.2zM393.2 298.5a56.8 56.8 0 0 0-14.8-24c1.5 17.2 10.6 26.7 14.8 24zM401.6 332.8c-5-3.7-19-5.4-21-4.8 10.2 8.4 20.2 8.5 21 4.8zM392.2 308a42 42 0 0 0-16.9-13.8c5.5 12.4 14.6 17 16.9 13.7zM395 260.4c.8-7.6-5.6-23.4-7.4-25.2-2.9 16 2.9 26.7 7.3 25.2zM399.4 245.5c2.7-6.5.8-22.4-.5-24.4-6.4 13.5-3.8 24.6.5 24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.4 237.8a40.3 40.3 0 0 0 3.5-19.4c-7.2 9.7-7 18.9-3.5 19.4zM410.4 231.7a38.8 38.8 0 0 0 9-17.4c-9.7 7-12.2 15.8-9 17.4zM394.3 274.9c.1.9-1-8.2-10-18.3.4 14.8 6.2 20.4 10 18.3zM426.9 360.7a53 53 0 0 0-25.8-6c12.6 10.4 24.9 10.6 25.8 6zM439 366c-4.6 1.5-10.5-9.5-7.6-26a99 99 0 0 0 7.5 26zM452.3 377c2 4.1-6.8 11.5-21.8 11.4 12-5 21.2-9.9 21.8-11.3zM459.6 372.6c4.9-2.3 1.1-15.5-14-26.4 8.6 13.2 14.5 24.6 14 26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.6 372.7c4.2-2.7-.7-14.5-16-22.7 9.5 11.2 16.2 21 16 22.7zM411.8 341.7c3.7.2 6-9.3.5-21 .7 11 .4 20-.5 21zM398 265c3 3.8 14-1.4 20.9-16a90.6 90.6 0 0 1-20.9 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.9 259.3c3.6 3.2 13.5-4.3 17.2-20-8 11.3-15.6 19.8-17.2 20zM426.6 358.4c4.7-1.1 4-13.8-7.3-26.3 5 13.5 8 24.8 7.3 26.3zM397.7 322c1.4-4.3-8.3-9.4-22.8-6.3 12.3 2.2 22 5 22.8 6.3zM395.8 312.4c2.9 1.8 9.1-4.7 10.3-16.7a68.6 68.6 0 0 1-10.3 16.7zM447 371c2.5 5-8 13.7-26 13.6 14.2-5.9 25.3-11.8 26-13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.4 326.3a45 45 0 0 0-17-15.8c5 13.6 14.2 19.1 17 15.8z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#67923d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.4 274c4-4.7 17.5-9.2 19.6-9-8 10.5-18 12.6-19.6 9zM417.5 351.5c-1.8 4-12.7 1-21.7-11.1a84.4 84.4 0 0 0 21.7 11.1zM393.1 298.5c-4.2 2.7-13.1-6.8-14.7-24 6.6 13.3 13 23.5 14.7 24zM401.5 332.8c-.7 3.7-10.7 3.6-20.8-4.7a74 74 0 0 0 20.8 4.7zM392 307.9c-2.3 3.2-11.2-1.3-16.7-13.7 8.2 8 15.5 13.7 16.8 13.7zM394.8 260.3c-4.4 1.6-10.1-9-7.3-25 2.7 13.5 6 24.2 7.3 25zM399.3 245.4c-4.3.3-6.9-10.8-.5-24.3-.8 12.8-.5 23.3.5 24.3zM404.3 237.8c-3.4-.6-3.7-9.7 3.6-19.4a66.2 66.2 0 0 0-3.6 19.4zM410.3 231.7c-3.1-1.7-.7-10.4 9-17.3a66.2 66.2 0 0 0-9 17.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.3 274.9c-3.9 2.1-9.6-3.5-10-18.3 5 11.7 8.6 17.8 10 18.3zM426.8 360.7c-.9 4.6-13.1 4.4-25.7-5.9 13.2 4.3 24.3 6.7 25.7 5.9zM418.6 351.2A41 41 0 0 1 412 332c9 8.7 10.2 18.1 6.8 19.2zM401.8 326.2c-3.6-5.8-4-20.9-3-23 8.3 11.9 7.3 22.7 3 23zM399.1 326.3c-2.7 3.3-11.9-2.1-16.8-15.8a77.3 77.3 0 0 0 16.8 15.8z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#406325"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.4 274c1.6 3.6 11.4 1.5 19.5-8.9-12 6.8-16.7 9.8-19.5 8.9zM401.7 326c4.3-.3 5.3-11-3-22.8a72.7 72.7 0 0 1 3 22.9zM418.7 351.2c3.4-1 2.2-10.5-6.7-19.2 4.4 9.7 7.2 18 6.7 19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.2 291.8c2-8.4-1.7-22.6-4.3-25.6-4.7 15.4-.2 26.6 4.3 25.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M394 293.8c-6 1.3-8.7-12-4.1-27.1 1 13.5 2.8 26.1 4 27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M392.7 293.7a53 53 0 0 1 9-24.7c2 15.8-4.5 26.3-9 24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M392.8 293.6c4.5 1.6 10.9-8.8 8.9-24.6-3.5 13.3-7.5 23.8-8.9 24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M394.1 303.3a50 50 0 0 1 10.6-23.7c.8 16.2-6.3 25.9-10.6 23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M394.2 303.4c4.2 2.2 11.3-7.4 10.5-23.5-4.4 12.8-9 22.9-10.5 23.5z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ba1f3e",
    stroke: "#511124",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 396.8,
    cy: 251.3,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.2,
    cy: 245.1,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.6,
    cy: 241.7,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392.5,
    cy: 313.1,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395,
    cy: 297.1,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408.2,
    cy: 334.5,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.4,
    cy: 336.4,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446.7,
    cy: 367.6,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 449.6,
    cy: 374.7,
    r: 1.3
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "#24420e"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M561.1 259c.7.6 1.2.8 2.3 1.9M556.8 242c0-1.4-.6-3.7-.9-5M559.4 240c0 1.9-.3 3.7-1.1 5.4M554.1 244.9c1.8 1.6 3.5 3 5.3 3.9M563.2 250c.1 2-.1 4-.7 6M562.9 257.5l1.3-2.3M562.3 267.4c1.4.3 2.8 2 3.5 3.5M566.3 269.6l1.6-2.2M569.6 298.2a24 24 0 0 1-2.4 3.4M563.2 301.6c.8 1.4 1.6 3 2.6 4M568.3 311.5a13.2 13.2 0 0 1-4.5 4M564 320c-1.1.8-2.5 3-3.7 4.7M568.7 304.5l-2.1.9M565.2 298l1.2 1M557.1 336.4h-2M553 334.6l.6 1.6M546 341.3c-.3 1.9-.1 3.7.1 5.6M550.4 337.9l1 2.2M555.3 340l-2.5.3M522 365.6l-1 1.8M532.9 363.4c-1.5.2-2.8 0-4.1-.2M523.3 369.2c-1-.5-2-.7-3-1M505.6 370.9c-.9.7-2 2.4-3 4M502 370.4c-2.4 1.3-3.2 3.7-4.4 5.8M500.4 379c-1.6-.4-3.4-1.2-5.3-2M511.8 376.3c-2.3-1.2-4.7-1-7.1-1.4M515.5 374.5c-3.7-.7-7-.6-10.3-.1M513 371.8l-1.4-.6M506 376.7l-2.3-1.3M561.6 326.2c-1.2.8-2.5 2.3-3.7 3.9M559.7 250.5l-2.2-.8"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M474.4 384.9c.8-1.3 2.1-2 3.3-2.7 7.7-4 15.4-5.8 24-7.2 2.1-.4 4.1-2.3 6.2-3.2 5-2.4 10.5-3.3 15.3-5.7.3-.2 1.5-.9 2-1.6 2-2.2 5.5-2.9 7.6-5 8.4-7.8 17.2-15 21.8-25.5 5.6-12.7 12.5-25.8 11.6-40.2-.6-9.2.7-18.4-1.5-27a104.6 104.6 0 0 0-15.4-36.4l1.3.8a103.8 103.8 0 0 1 15.4 36.4c2.3 8.6 1 17.9 1.5 27 1 14.4-6 27.5-11.5 40.3-4.6 10.4-13.5 17.6-21.8 25.5-2.2 2-5.6 2.7-7.6 5a10 10 0 0 1-2 1.5c-4.9 2.4-10.4 3.4-15.4 5.7-2 1-4 2.8-6 3.2A76.5 76.5 0 0 0 479 383a8 8 0 0 0-3.3 2.7l-1.3-.8"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#406325"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M553.6 334.6c2.8-7.4 0-24.8-1.4-27-6.7 15.4-3.4 27.6 1.4 27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.5 341.6c2.3-5.6.7-19.3-.4-21-5.5 11.7-3.3 21.3.4 21zM563.4 267.5a46.9 46.9 0 0 0-19.3-14.6c6.2 13.3 16.5 18.2 19.3 14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.8 259.5a43.3 43.3 0 0 0-14.5-16.7c3.1 13 11.4 19.3 14.5 16.7zM566.5 274.4c-3.5-4-15.2-7.9-17-7.7 7 9 15.6 10.9 17 7.7zM563.7 320.8a40 40 0 0 0 20.3-5.7c-12.9-2.8-21.5 1.9-20.3 5.7zM563.5 315.1c0-5.6-6.3-16.8-8-18-.5 12 4.9 19.5 8 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564 301.4a50 50 0 0 0-10.6-23.6c-.8 16.2 6.3 25.8 10.6 23.6zM511 376.7a47.7 47.7 0 0 0 22.2 11c-8.8-12.3-20.1-15.1-22.1-11z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#67923d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M553.6 334.4c-4.9.6-8.1-11.4-1.4-26.8-.5 14.2.2 25.7 1.4 26.8zM500.2 378a50 50 0 0 1 21.9 11.5c-15.1.1-24-7.3-22-11.4zM500.2 370.1c2-8 15-21.2 17.5-22.1-3.6 17.1-13.7 25.5-17.5 22.1zM521.5 366a54 54 0 0 1 7.5-26c3 16.4-3 27.5-7.5 26zM543 351.4a48.8 48.8 0 0 1 21.6-11.2c-8.9 12.1-19.8 15.1-21.7 11.2zM568.7 298.1c1-6.3 9.7-17.9 11.6-18.9-1.2 13.6-8.3 21-11.6 19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557 336.2a50.5 50.5 0 0 1 24.4-5.5c-11.8 9.7-23.5 9.8-24.4 5.5zM567.3 311.7a44 44 0 0 1 17.7-14.4c-5.8 13-15.3 17.8-17.7 14.4zM565.8 266.1c0-7.6 8-22.7 10-24.2 1.1 16.1-5.7 26.2-10 24.2zM558.9 240.2a40.4 40.4 0 0 1-.1-20c5.5 10.9 3.7 20 0 20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.6 238a49.7 49.7 0 0 1-10.4-22.1c11.8 9.3 14.4 20.4 10.4 22.1zM566.3 272.5c-.3.9 3-7.7 14.2-15.3-4 14.3-11 18.3-14.2 15.3zM532.2 362.4a61 61 0 0 1 29.2-6.7c-14.2 11.8-28.2 12-29.2 6.7zM546.5 341.6c-3.7.2-6-9.3-.5-21-.7 11-.4 20 .5 21zM563.4 267.5c-2.7 3.6-13-1.2-19.2-14.6a78.8 78.8 0 0 0 19.2 14.6zM561.7 259.5c-3.1 2.6-11.3-3.6-14.4-16.7 6.7 9.4 13 16.5 14.4 16.7zM566.5 274.5c-1.4 3.1-9.9 1.3-16.9-7.7 10.4 5.9 14.5 8.4 17 7.7zM563.9 320.7c-1.3-3.8 7.3-8.3 20.2-5.5a69 69 0 0 0-20.2 5.5zM563.5 315.1c-3.2 1.5-8.5-5.9-8-17.9a68.7 68.7 0 0 0 8 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.9 301.6c-4.3 2.2-11.3-7.4-10.5-23.5 4.4 12.8 9 22.9 10.5 23.5zM511.2 376.7c2-4.2 13.1-1.4 22 10.8-11-6.7-20.5-11.3-22-10.8z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#406325"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M521.5 365.8c4.6 1.6 10.5-9.4 7.6-25.9-2.8 14-6.2 25.1-7.6 26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.8 360.6a55 55 0 0 0 4.6-27c-10 13.6-9.4 26.3-4.6 27zM500.1 378.1c-2 4.1 6.7 11.5 21.8 11.3-12-4.8-21.2-9.8-21.8-11.3zM500.3 370c3.8 3.4 13.8-4.9 17.4-22-8.1 12.4-15.7 21.8-17.4 22zM543 351.4c1.8 4 12.7 1 21.7-11.1a84.4 84.4 0 0 1-21.7 11.1zM568.8 298.1c3.3 2.1 10.3-5.3 11.5-18.8a74.8 74.8 0 0 1-11.5 18.8zM557 336.2c1 4.4 12.5 4.2 24.4-5.5-12.5 4-23 6.2-24.3 5.5zM567.4 311.6c2.5 3.4 11.9-1.4 17.7-14.4a75 75 0 0 1-17.7 14.4zM566 266c4.2 2 11-8 9.8-24-4 13-8.4 23.3-9.9 24zM559 240.1c3.5.1 5.4-9-.2-20 1 10.5 1 19.1.2 20zM554.7 237.9c4-1.7 1.4-12.7-10.4-22a81.7 81.7 0 0 1 10.4 22zM566.3 272.6c3.2 3 10.2-1 14.2-15.4-7.8 10.1-12.7 15.2-14.2 15.4zM532.3 362.5c1 5.2 14.9 5 29-6.7-14.9 4.8-27.4 7.6-29 6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.1 354.8a41 41 0 0 0 3.6-20.1c-7.5 10-7.2 19.5-3.6 20zM558.7 326.1c3.6-5.7 4-20.9 3-23-8.3 11.9-7.3 22.7-3 23z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#67923d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.8 360.5c-4.8-.6-5.3-13.3 4.5-26.8-3.6 13.8-5.4 25.4-4.5 26.8zM567 292.2c-1-7.8 4-20.1 6.6-22.5 2.6 14.4-2.7 24-6.6 22.5zM539.1 354.7c-3.6-.5-3.9-10 3.6-20a67.4 67.4 0 0 0-3.6 20zM562.5 250.5c-2.2-6 0-20 1.2-21.8 5.3 12.2 2.6 22.1-1.2 21.8zM504.4 370.6c2.5-8 16.2-21 18.8-22-4.3 17.5-15 25.6-18.8 22zM559 329a45 45 0 0 1 16.9-15.8c-5 13.6-14.2 19.1-17 15.8zM558.8 326c-4.3-.4-5.3-11 3-22.9a72.7 72.7 0 0 0-3 22.9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M567 294c5.2 1.9 9-9.8 6.6-23.9a98 98 0 0 1-6.6 24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M567.8 293.6c.5-7.5-7-23-9-24.7-2 15.8 4.5 26.3 9 24.7zM562.5 250.4c3.9.4 6.5-9.4 1.2-21.7.4 11.5-.2 20.8-1.2 21.7zM504.5 370.5c3.8 3.7 14.4-4.4 18.7-21.8-8.8 12.3-17 21.6-18.7 21.8zM559.1 329c2.8 3.3 12-2.1 17-15.8a77.3 77.3 0 0 1-17 15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M567.7 293.5c-4.5 1.7-10.9-8.7-8.9-24.5 3.5 13.2 7.5 23.7 8.9 24.5z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ba1f3e",
    stroke: "#511124",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 564.6,
    cy: 254.9,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 568.4,
    cy: 266.8,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.8,
    cy: 304.3,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.6,
    cy: 297.3,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 549.9,
    cy: 337.2,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 556.2,
    cy: 339.9,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 513.8,
    cy: 372.3,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 506.8,
    cy: 377.3,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 557.1,
    cy: 249.3,
    r: 1.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "c",
    fill: "#8c959d",
    stroke: "#485654",
    strokeWidth: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.3 336.3c-.2 1 .8 2.3 2 2 .5 0 .7-.5.2-.5-.4.2-.9 0-1.2-.3a2 2 0 0 1-.4-2l-.6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M437.2 338.3c-1 1.2-2.5 1.7-3.4.9-.6-.6-.8-1.2-.5-2l-1 1.3s.6 1.3 1.6 1.8c1.3.5 3-.3 4-1.6.8-1 1.6-2.4 1-3.6a4 4 0 0 0-2-1.7l-1 1c.5-.2 1.2 0 1.7.4 1.3 1 .6 2.5-.4 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#485654",
    stroke: "none",
    d: "M437.2 338.3a4 4 0 0 1-1.1 1c-.5.2-1 .4-1.5.3a1 1 0 0 1-.7-.3 1 1 0 0 1-.5-.6c-.2-.2-.2-.4-.3-.7 0-.3 0-.5.2-.8l.1.1-1.1 1.3v-.1l1 1.3.7.4.8.1a3 3 0 0 0 1.6-.5c.5-.2 1-.6 1.3-1l1-1.4c.2-.5.4-1 .3-1.6 0-.3 0-.5-.2-.8a4.2 4.2 0 0 0-1.9-1.6h.1l-1 1.1h-.1c.2-.2.5-.2.7-.2l.8.2c.4.3.8.7.9 1.2.1.5 0 1-.2 1.4-.2.5-.5.9-.9 1.2zm0 0c.4-.3.6-.7.8-1.2.2-.4.3-1 .2-1.4-.1-.5-.5-.8-.9-1-.4-.3-1-.4-1.3-.2h-.1l1-1.2a4.2 4.2 0 0 1 2 1.7c.2.2.3.5.3.8 0 .6-.1 1.2-.4 1.7-.2.5-.5 1-1 1.4-.3.5-.8.8-1.3 1.1-.5.3-1 .5-1.7.5a2.2 2.2 0 0 1-1.6-.6 5 5 0 0 1-1-1.4l1-1.3h.2l-.1.8c0 .2 0 .5.2.7l.5.5c.1.2.4.3.6.3.5.1 1 0 1.5-.2l1.1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6c301e",
    stroke: "#351710",
    strokeLinejoin: "round",
    strokeWidth: 0.2,
    d: "m515.2 249.3-40.1 39.5L434 328l-4.6 5.4c-2 2.3-4.4 5.3-7.2 8-.5.7-1.1.4-1.7.8-1.8 1-3.7 2.8-5 4.3L403.2 360c-.7.9-1 1.4-.4 2l6.6 8.8c1.2 1.2 2.6 1.8 3.2.8 3.1-5.5 11-13.8 14-20.3 1.7-4 3.9-11.1 5.5-12.8 2-2.2 7.1-7.8 11.8-12.7l1-1c.2-.4.5-.7.9-1 23.5-24 50.7-53.1 70.5-73.6l-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.9 328.1c-1.2 0-2-.7-2.9-1.4 1.2.4 2.4.8 3.5.3l-.6 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b6ba",
    strokeWidth: 0.2,
    d: "m557 220.1-31.8 26.2c-.3.4-.6.3-.9 0l-2.9-2.4v-.6l1.4-1.4c.2-.2 0-.3-.1-.6l-.6-.6c-.3-.1-.5 0-.7.2l-1.4 1.5c-.7 0-1.3.6-1.4 1.4-19.2 18.7-35.8 35.4-54.9 53.8l-22.6 21.6c-.8 1-4.3 2.9-6.6 4.4-.8.5-1.5 1-1.8 1.5l-1.8 5.5c-.6 1.2-2.5 4-2.5 4.2l3.8 3.7 11.1-11.9.9-1a13.3 13.3 0 0 0-2.6-2.7l-.7-.5c-.1-.2.3-.5.5-.7 26.4-25.6 55-53.7 78.2-76.6a1.4 1.4 0 0 0 1 0l2.9 3.1c.6.7 1.2.7 1.7.4l31.9-28.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#485654",
    stroke: "none",
    d: "M431 330.4h.6l.5-.1.7-2.4.8-2.4c-.2-.2-.4-.4-.7-.4.3 0 .5.2.7.4l-.7 2.4-.7 2.4-.6.2-.7-.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.2,
    cy: 328.1,
    r: 0.6,
    fill: "none",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.4,
    cy: 331.9,
    r: 0.6,
    fill: "none",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#485654",
    stroke: "none",
    d: "M441 322.4a11.7 11.7 0 0 1-1.8-1.6 11.6 11.6 0 0 1 1.8 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m502.2 259 3.5 3.5.6-.6-3.5-3.4-.6.6z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: "100%",
    height: "100%",
    transform: "scale(-1 1) rotate(-2.8 -9.3 19640.2)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#24420e",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M434 365.4a55.8 55.8 0 0 0-29.3.9c16.3 8 29.5 4.6 29.2-1zM523 368.7c7.8-3.3 26.8-.7 29.1 1-16.2 7.9-29.5 4.5-29.2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M433.8 365.5c.3 5.5-12.8 8.9-29.1.9 15.3 1 27.8.4 29-1zM523 368.8c-.2 5.5 12.9 8.9 29.2.9-15.3 1-27.8.4-29.1-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b2b6ba",
    stroke: "#485654",
    strokeWidth: 0.2,
    d: "M508.5 360a237.5 237.5 0 0 0-76.1-68c3.5-.2 11.4 3.9 14.7 6 23.9 15.4 44.3 35.8 65.6 59.8-1.2 1.2-2 2-3.4 3l-.8-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c959d",
    d: "M510.6 359.8 509 361c-23-29.6-55-57.9-76.7-69 30.1 13.8 55.4 41.7 78 67.6h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#485654",
    d: "M510.6 359.8 509 361a303 303 0 0 0-35.2-38 285 285 0 0 0-30.4-24.3c-3.6-2.4-7.3-4.7-11.1-6.7v-.2c8 3.7 15.4 8.2 22.5 13.3 7 5 13.6 10.7 20 16.6a360 360 0 0 1 18.3 18.5c6 6.4 11.6 13 17.4 19.5zm0 0c-5.8-6.6-11.5-13-17.5-19.4a355 355 0 0 0-18.3-18.5c-6.4-5.9-13-11.5-20-16.6-7-5-14.5-9.6-22.4-13.2v-.2a196.2 196.2 0 0 1 21.7 14.3 284.9 284.9 0 0 1 38.2 35.1 314 314 0 0 1 16.8 19.8l1.5-1.3z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fab81c",
    stroke: "#6c301e",
    strokeWidth: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.2,
    d: "M517.5 355c-2 .6-3.7 1.3-5.3 2.3-.2 1.4-2 3-3.5 3.3l-.6-.8h-.2l-.6.3c-.6 0-1.3.2-1.6 1-.4 1 .3 2.3 1.2 3.1 1 .7 1.4 1 2.4 1 1.1-.3 1.7-1.3 2-1.6 3.7 4.5 6.5 7 11.2 10.6 2.1 0 3.2-1.3 2.5-2.8-.2-.5-.8-.8-1.3-.6v-.5c2.4-2.2 3.5-5 .9-9.8-2.2-4-4.7-5.4-7-5.4h-.1zm6.2 4.6c.5.7.7 1.4 1 2 1.6 3 .3 6.7-2.3 7.8h-.2c.4-.7-.8-2.2-1.4-1.7.3-.7-.7-2-1.5-1.7.4-.7-.5-1.9-1.4-1.5.4-.7-.3-1.8-1.3-1.6.3-.8-.4-1.8-1.3-1.6 0-.8-.2-1.2-.5-1.5 1-.8 2.3-2.1 3.4-2.7 2.7-1.2 4.4 1 5.5 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.9 362.8c-.5-.3-.8-.8-.6-1.1.2-.4.7-.5 1.2-.2.5.2.8.7.7 1-.2.4-.8.5-1.3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.6 361.8c-.5-.3-.8-.8-.6-1.2.2-.3.7-.4 1.2-.1.5.2.8.7.7 1-.2.4-.8.5-1.3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524 360.6c-.5-.2-.8-.7-.6-1 .2-.4.7-.5 1.2-.3.5.3.8.8.6 1.1-.1.4-.7.5-1.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.2 359.6c-.5-.3-.8-.8-.6-1.1.2-.3.7-.4 1.2-.2.5.3.8.8.7 1.1-.2.3-.8.5-1.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.2 358.6c-.6-.2-.8-.8-.6-1v-.2c.2.1.7.2.6-.1 0-.2-.1-.3 0-.2l.6.2c.5.3.8.8.6 1.1-.1.4-.7.5-1.2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fab81c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M511.3 363.6c.7-1.8 2-3.4 3.5-3.8M511.5 363.9c1.3.2 3.3-1.3 3.8-2.6M512.7 365.3c1.6.4 3.3-1.2 4-2.4M514.2 366.9c2 0 3.1-1.3 3.7-2.4M515.7 368.4c1.7 0 3.2-1.3 3.6-2.4M517.1 369.8c1.9 0 3.1-.9 3.7-2M518.8 371.2c1.7.1 3-.9 3.4-1.8M520.6 372.7c1.6 0 2.7-1 3.1-2"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#6c301e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M511.3 363.6a7 7 0 0 1 2.3-3.2c.3-.3.7-.5 1.2-.6a4 4 0 0 0-1.2.6 6 6 0 0 0-1 1 8 8 0 0 0-1.3 2.2zM511.5 363.9c.4 0 .8 0 1.2-.2l1-.6 1-.8.6-1a2 2 0 0 1-.6 1 5.3 5.3 0 0 1-2 1.4c-.4.2-.8.3-1.2.2zM512.7 365.3h1.2l1-.6a5.6 5.6 0 0 0 1.7-1.8l-.7 1-.9.9-1 .5h-1.3zM514.2 366.9c.4 0 .8 0 1.1-.2l1-.5 1-.8.6-1a4 4 0 0 1-1.5 1.9l-1 .5h-1.2zM515.7 368.4c.8 0 1.5-.3 2.1-.8a5.2 5.2 0 0 0 1.5-1.6c-.1.3-.3.7-.6 1l-.8.7-1 .6a3 3 0 0 1-1.2.1zM517.1 369.8c.4 0 .8 0 1.1-.2a4.6 4.6 0 0 0 2-1l.6-.9-.6 1c-.3.2-.6.5-1 .6-.6.4-1.3.5-2 .5zM518.8 371.2a4.5 4.5 0 0 0 2-.5l.8-.5c.2-.3.5-.5.6-.8 0 .3-.3.6-.5.8a3.6 3.6 0 0 1-3 1zM520.6 372.7l1-.1.8-.4.7-.6.6-.8a3 3 0 0 1-3.1 1.9z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: "100%",
    height: "100%",
    transform: "scale(-1 1) rotate(-3.4 -13.8 16470.8)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#24420e",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M409.2 240a52.4 52.4 0 0 0 19.5-17.9c-15.6 4.2-22.7 14.3-19.5 18zM555 244.7a50 50 0 0 0-15.6-19.9c2.8 15.2 12 22.8 15.6 20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M409.2 240c-3.3-3.6 3.8-13.6 19.4-17.8-11 8.4-19.2 16.2-19.4 17.8zM555 244.7c-3.7 3-12.7-4.6-15.5-19.7 7.2 11 14 19.5 15.5 19.7z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#999270",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M452.2 318.1s-6.1.7-7.9-7.8c-1.8-9.1 5.3-10 5.3-10s8.1-.9 13.2-1l2.2 18-12.8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M453 315.4s-4 .7-4.8-5.6c-.6-4.5 2.2-5.1 2.2-5.1l9.2 1.6v8.2l-6.6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M450.4 304.7s6-.4 9-.8l1.3 5.7-7.1.4s-.5-5.1-3.2-5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M449.2 300.4s7.5-1.9 8.5 6.4c.2 2.2-1 7.2-4.7 8.6l13.9-1.5-1.3-15-4.6.4s-10 .3-11.8 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9f0aa",
    d: "M452.2 318.1s51.9-3.5 57.2-3.3c15.8-8.6 0-42.5-13.3-61.5 1.5-4.3-29.9-13.9-44-13-1.9 0-3.6.2-5.2.3-7.7.8-7.8 10.7-4.7 17 3 6 30.4 55 11.2 60.3l-1.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M507.8 273.3c-3.5-7.3-7.7-14.3-11.7-20 1.5-4.3-29.9-13.9-44-13-1.9 0-3.6.2-5.2.3-7.7.8-7.8 10.7-4.7 17 1 1.8 4.3 8 7.9 15.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M455 285c5.6 14.6 8.7 30-1.6 32.9l-1.2.2s52-3.5 57.2-3.3c8.6-4.7 7.8-16.8 3.2-30"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M447.4 243.5c-3.7 0-4.7 3.6-4.6 5.8.1 6 4.6 6.2 4.6 6.2l6-.3 2.8-12.2-8.8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "m447.4 243.5 8.8-.5 1 9.1-7.8.4s2.5-7.3-2-9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M496.1 253.3c6.7-1 6.6-10 2-13.7-15.5-.6-35.8-.1-50.6 1 1.7 0 6.4.4 6.9 6.5a8.2 8.2 0 0 1-3 7 7 7 0 0 1-4 1.4h3.6l3-.4c21-2.7 42-1.8 42-1.8h.1z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#b07e09",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.5 267.4c-.2-.3-.4-.7-.8-.8-.2 0-.6 0-.5-.4h.8l1.6-.2c.4.1.3.5 0 .5-.5 0-.2.5-.1.8l1.3 3c.1.4.4.7.7.7l1.1-.1c.3-.2.2-.6.2-1-.1-.3.5-.2.5 0l.4 1.4c0 .2-.2.1-.4.1l-3 .2c-.3 0-.8.3-1 0 0-.4.6-.2.6-.5l-.3-1-1.1-2.7zM463.3 267c-.1-.2-.3-.6-.7-.7-.2 0-.6 0-.6-.4.2-.2.5 0 .7 0l1.7-.2c.3 0 .4.5 0 .4-.3 0-.3.4-.2.7l1.5 3.4c0 .2.2.5.5.6.2 0 .6 0 .7.3 0 .3-.4.1-.6.1-.5 0-1 0-1.6.2-.2 0-.5 0-.5-.3s.5 0 .6-.4c0-.3-.2-.6-.4-1l-1.1-2.6zM467.8 267.8c0 .2.4 0 .5 0 .3 0 .6-.1.6-.4 0-.5-.3-1-.7-1.2-.3-.3-.7-.2-1.1-.2l.1.5.6 1.3zm.6 1.6c.2.3.3.7.6 1 .2.2.6.1.8 0 .3 0 .5-.3.4-.5-.1-.7-.5-1.3-1.2-1.5h-1l.2.5.2.5zm-2-2.4c-.2-.3-.3-.8-.7-1-.2 0-.6.1-.7-.2 0-.3.6-.1.8-.2.9 0 1.8-.3 2.6 0 .7.2 1.4.8 1.5 1.6 0 .4-.3.7-.6.8l.5.1c.6.2 1.1.6 1.4 1.2.2.4.3.9 0 1.3-.4.4-1 .4-1.4.4-.8 0-1.5 0-2.3.2-.3 0-.4-.5 0-.5.3 0 .3-.4.2-.6l-1.3-3zM473.8 265.1c.3 0 .4.3.5.5l.3.9c-.3.2-.5-.2-.6-.4-.2-.2-.4-.5-.7-.4h-1.2c-.2.2 0 .4.1.6l.6 1.4c.2 0 .6 0 .8-.3 0-.2-.3-.7.2-.6.3.2.2.6.4.9l.5 1.1c-.3.3-.5-.1-.6-.4-.2-.3-.7-.3-1-.3-.2 0 0 .2 0 .3l.6 1.5c.2.3.7.3 1 .3.3 0 .8 0 1-.4.2-.2-.3-.7 0-.8.4 0 .4.4.5.6 0 .3.2.6.3.8 0 .2-.3.2-.4.2l-3 .2c-.4 0-.9.2-1-.2 0-.3.7-.1.6-.5l-.4-1-1.1-2.7c-.2-.3-.4-.7-.8-.7-.2 0-.6 0-.4-.4h1l2.8-.2zM476.1 266.4c-.1-.3-.3-.7-.7-.9-.2 0-.7 0-.7-.4.3-.2.7 0 1 0 .8 0 1.6-.3 2.4 0 .8.1 1.5.9 1.6 1.8 0 .4-.3.7-.7.8-.3 0 .2.1.3.2.7.3 1 .9 1.4 1.5.1.2.5.7.6.2 0-.5.6 0 .5.3 0 .4-.4.6-.7.6-.4 0-.9-.2-1.1-.6-.4-.6-.7-1.3-1.3-1.7a.8.8 0 0 0-.8-.2v.5l.6 1.2c.2.3.6.3 1 .3.3.1.2.6-.2.5h-1.7c-.3.2-.9 0-.7-.3.3 0 .7-.2.5-.5l-1-2.6-.3-.7zm1.4 1c.2.2.6 0 .9 0 .3 0 .3-.5.2-.7-.1-.5-.4-1-.9-1.2-.2 0-.8-.2-.9.1l.7 1.6v.1zM484.7 269c.1.3.3.6.6.7.2 0 .6 0 .7.3 0 .3-.4.1-.6.2h-1.6c-.3.1-.6 0-.6-.3.2-.2.7 0 .7-.4l-.5-1.1-1.1-2.9c-.1-.3-.5-.3-.7-.3-.3 0-.7 0-.7.4 0 .3.2.6 0 .8-.3 0-.4-.3-.5-.5 0-.3-.2-.6-.4-1 0-.2.4-.1.5-.1l4.2-.2c.3 0 .5.2.5.5l.4 1c-.1.3-.5 0-.6-.3-.1-.3-.5-.7-.9-.7-.2 0-.6 0-.8.2l.2.7 1.2 3zM488.5 268.1c-.2 0-.1.3-.1.4v.8c.1.4.5.3.8.4.2 0 .1.5-.2.4h-1.2c-.3.1-.8-.1-.5-.4.2 0 .4-.1.5-.3v-5c.2-.3.5 0 .6.2l3.6 4.5c.2.2.5.4.8.4.3 0 .4.5 0 .4h-1.5c-.2 0-.5.2-.7 0-.2-.1 0-.4.2-.4.3 0 0-.4-.1-.6l-.6-.8h-1.6zm1.1-.5c.2 0 0-.1 0-.2l-1.3-1.7v2h1.3zM492.7 265.8c-.1-.4-.3-1-.8-1-.3 0-.7-.2-.5-.4h1.7c.7-.1 1.4-.1 2 .1 1.5.5 2.7 1.8 3 3.4 0 .6-.1 1.3-.6 1.6-.8.5-1.7.4-2.5.3l-1.4.1c-.3 0-.4-.5 0-.4.4 0 .4-.5.2-.7l-1.1-3zm2 2.5c.1.3.2.7.5 1h1c.5 0 .7-.5.7-.9a5 5 0 0 0-.6-2.1c-.4-.7-1-1.2-1.8-1.4a3 3 0 0 0-1 0c-.1 0 0 .2 0 .4l1.2 3zM473.6 280.7c0 .3.4.6.8.6.2 0 .7 0 .7.4-.2.2-.6 0-.8 0l-1.5.2h-.9c-.2 0-.2-.4.1-.4.3 0 .6-.1.6-.4l-.2-.8-1.2-2.8c0-.3-.4-.3-.7-.3-.2 0-.6.1-.7-.2 0-.3.5-.2.7-.4l1-.3c.2 0 .3.1.3.3l1.8 4zM474.3 276.2h2c.4 0 .2-.5.4-.5.4 0 .4.5.4.7 0 .4-.3.7-.6.6H475l.5 1.2.6-.2c1 0 2.2.6 2.6 1.6.2.5.3 1 0 1.5-.4.5-1 .6-1.6.6-.5 0-1-.1-1.4-.6-.1-.2-.1-.7.2-.6.4 0 .7.2.7.6.1.2.5.1.7.1.3 0 .6-.2.6-.5 0-.5-.2-1-.5-1.4-.2-.4-.7-.7-1.3-.7l-.8.1c-.3 0-.3-.3-.4-.5l-.7-1.9.2-.1zM481.2 277.2c-.2-.4-.4-.9-.9-1-.2 0-.7-.1-.4-.4h1.6c.7-.2 1.5-.1 2.1.1 1.5.5 2.7 1.8 3 3.4 0 .6-.1 1.2-.7 1.6-.7.4-1.6.3-2.4.3l-1.3.2c-.3 0-.4-.5 0-.5.3 0 .3-.4.2-.7l-1.2-3zm2 2.5c.1.3.3.7.6 1h1c.4-.1.6-.6.6-1 0-.7-.3-1.4-.7-2.1-.4-.7-1-1.2-1.8-1.3a3 3 0 0 0-1 0v.4l1.3 3zM489.6 275.4c.3 0 .4.3.5.5 0 .3.2.5.3.8-.2.3-.5 0-.6-.3-.1-.2-.3-.5-.6-.5h-1.3c-.2.2 0 .5 0 .6l.6 1.4c.3 0 .6 0 .8-.2.2-.2-.3-.7.2-.6.3 0 .3.5.4.8l.5 1.1c-.1.4-.5 0-.6-.3-.1-.3-.5-.3-.8-.3-.2 0-.4 0-.2.2l.6 1.5c.2.4.7.3 1 .3.4 0 .8 0 1-.3.2-.2-.2-.6 0-.8.4 0 .5.3.5.5l.3 1c0 .1-.3 0-.4 0l-3.1.2c-.3 0-.7.2-.9-.1-.2-.4.5-.2.6-.5l-.3-.9-1.1-2.9c-.2-.3-.4-.6-.8-.7-.2 0-.6 0-.4-.4h1l2.8-.1zM462.4 289.7c.1.5.6.7 1 .8.8.2 1.7.5 2.2 1.1.3.4.5.9.5 1.4 0 .5-.5.9-1 1-.5.2-1.1.1-1.7-.1-.2-.1-.1.4-.5.3-.2-.2-.1-.6-.2-.9a9 9 0 0 0-.4-1c0-.3.4 0 .5.2.3.6.9 1 1.6 1.1.4 0 .8-.2.8-.6 0-.5-.4-1-.8-1.2-.7-.3-1.4-.4-2-.8a2 2 0 0 1-1-1.6c0-.4.4-.8.8-.9.5-.2 1-.2 1.6 0 .2 0 .3-.3.6-.1 0 .2 0 .4.2.6l.3.9c-.2.2-.5 0-.5-.2-.3-.4-.5-.8-1-.8-.4 0-.8 0-1 .3v.5zM469 288c.4 0 .4.3.5.5l.2.8c0 .3-.4 0-.5-.2-.1-.2-.3-.5-.7-.5h-1.2c-.2.2 0 .5 0 .6l.5 1.4c.3 0 .6 0 .8-.2.2-.2-.2-.6.1-.7.4 0 .4.5.5.7 0 .4.3.8.4 1.3-.1.3-.5 0-.5-.3-.1-.3-.5-.4-.8-.3-.2 0-.4 0-.3.2l.6 1.5c.1.3.4.3.7.3.4 0 .9 0 1.2-.3.2-.2 0-.6 0-.8.3-.2.6 0 .6.3l.2 1c0 .2-.3.2-.4.2l-3 .2c-.4 0-.8.3-1 0 0-.4.5-.3.6-.6 0-.2 0-.5-.2-.8l-1-3c0-.3-.3-.6-.7-.6-.2 0-.6-.1-.4-.4h1l2.8-.3zM473.2 292.2c.1.3.3.6.6.7.3 0 .7-.1.8.2 0 .4-.5.2-.7.2-.6 0-1 0-1.6.2-.2 0-.5 0-.6-.2 0-.4.5-.2.6-.4l-.1-.8-1-3c-.2-.3-.3-.7-.7-.7-.2 0-.6 0-.5-.4.1-.2.4 0 .7 0 .7 0 1.4-.3 2.2-.2a2 2 0 0 1 1.7 1.2c.2.4.2 1 0 1.3-.5.4-1.1.5-1.7.6-.2 0 0 .2 0 .3l.3 1zm-.6-1.8h.7c.3-.1.5-.4.4-.7 0-.5-.2-.9-.5-1.2-.3-.3-.8-.3-1.1-.2-.2.1 0 .3 0 .5l.5 1.6zM478.8 291.9c0 .2.2.6.5.6.2 0 .7 0 .7.3s-.5.2-.7.2l-1.6.1c-.2 0-.5 0-.5-.3.2-.2.7 0 .7-.4l-.3-1.2-1-2.9c0-.3-.4-.2-.7-.2-.2 0-.6 0-.7.3v.8c-.2.2-.5 0-.4-.3l-.4-1c0-.3.3-.2.5-.3l4.1-.2c.3 0 .5.2.5.5l.4 1c-.1.2-.5 0-.5-.2-.2-.3-.5-.7-1-.7-.2 0-.5-.1-.8 0l.2.7 1 3.2zM480.9 288.6c-.1-.3-.2-.7-.6-.8-.2 0-.6 0-.6-.4.1-.2.4 0 .6 0l1.8-.2c.3-.1.5.4.2.4s-.6.2-.5.5l.5 1.6.7 2.2c0 .2.3.4.5.4.3 0 .7 0 .6.4h-.7l-1.6.2c-.2 0-.6-.2-.4-.4.2-.1.6 0 .6-.4l-.3-1.2-.8-2.3zM486.7 287c.3 0 .3.3.4.5l.2.8c-.1.3-.5 0-.5-.2-.1-.3-.3-.6-.7-.6H485c-.2.2 0 .5 0 .7l.5 1.3c.2 0 .5 0 .8-.2.2-.1-.2-.6.1-.6.4 0 .4.4.5.6 0 .5.3.9.4 1.3-.1.3-.5 0-.5-.2-.1-.3-.5-.4-.8-.4-.1 0-.5 0-.3.2l.5 1.5c.1.3.5.4.7.4.4 0 .9 0 1.2-.3.2-.2 0-.6.1-.9.3-.1.5.1.5.4l.2 1c0 .2-.2.2-.4.2l-3 .1c-.4 0-.7.2-1 0-.1-.4.5-.3.6-.5a1 1 0 0 0-.1-.8l-1-3c0-.3-.3-.7-.7-.7-.2 0-.6-.2-.4-.4h1l2.9-.2zM488.7 288c-.1-.4-.4-.7-.8-.7-.3.1-.5-.6 0-.4h1.5l.7.9 2.2 2.9c-.2 0 0-.2-.1-.3l.4-3.6c.2-.2.7 0 1-.2.3 0 1 0 .8.4-.4 0-.8.2-.6.6l1.2 3.6c0 .4.4.6.8.5.3 0 .3.6 0 .5H494c-.3.1-.8.1-.7-.3.3 0 .8-.2.6-.6l-1-3.2c.1.1 0 .3 0 .4l-.2 3-.1.8c-.3.1-.4-.1-.5-.3l-2.9-3.7.2.3c.3 1 .5 2 .9 2.9 0 .4.5.5.8.5.4.2.1.5-.2.4h-1.5c-.3 0-.3-.4 0-.4.5 0 .4-.5.2-.8l-1-3.2zM497.4 288.8c0 .2.4 0 .5 0 .3 0 .6 0 .7-.4 0-.4-.2-1-.5-1.2-.4-.3-.8-.2-1.2-.2v.5l.5 1.3zm.5 1.6.4 1c.3.2.6.1.9.1.2 0 .5-.2.4-.5 0-.6-.3-1.3-.9-1.5h-1v.3l.2.6zM496 288c-.1-.4-.2-.8-.6-1-.2 0-.6 0-.6-.3s.5 0 .7-.1c1 0 1.8-.2 2.7 0 .7.2 1.3.9 1.3 1.6 0 .4-.4.7-.7.9 0-.2.4 0 .5 0 .5.2 1 .6 1.2 1.2.2.4.3.9 0 1.3-.4.4-1 .4-1.5.4l-2.3.1c-.3 0-.4-.5 0-.4.3 0 .4-.4.2-.7l-.9-3zM501.1 287.8c0-.3-.2-.8-.6-1-.2 0-.6 0-.6-.3.2-.3.6 0 1-.1h2c.8 0 1.5.6 1.7 1.4.1.4 0 1-.4 1.2l-.4.2c.6.2 1.1.7 1.4 1.2l.5.8c.2.2.3-.1.3-.3.4-.2.6.3.4.6-.1.4-.7.5-1 .4a.9.9 0 0 1-.8-.6l-1-1.7c-.3-.1-.6-.3-.9-.1v.4l.5 1.2c.1.3.5.4.8.4.4 0 .4.5 0 .4h-1.8c-.2 0-.6.2-.7 0-.2-.5.4-.3.6-.5l-.2-.9-.8-2.7zm1.3 1c.1.3.6 0 .8 0 .3 0 .5-.3.4-.5 0-.5-.2-1-.5-1.3-.3-.2-.7-.2-1-.1-.2 0-.1.3 0 .5l.3 1.3zM509.3 286.2c.3 0 .3.3.4.5 0 .3.2.6.3.8-.2.3-.5 0-.6-.2 0-.2-.2-.6-.6-.6h-1.3c-.2.1 0 .4 0 .6l.4 1.4c.3 0 .6 0 .8-.2.3-.1-.1-.5.2-.7.4 0 .4.4.4.7 0 .5.3.9.4 1.3-.1.3-.5 0-.5-.2 0-.3-.4-.5-.7-.4-.1 0-.5-.2-.4 0l.5 1.7c.1.3.4.3.7.3.4 0 .9 0 1.2-.2.2-.2 0-.6.1-.8.3-.2.6 0 .5.3l.2 1c0 .2-.3.2-.4.2h-3.1c-.3 0-.6.2-.8 0-.3-.4.2-.3.4-.5s0-.5 0-.7l-.9-3.1c0-.3-.3-.7-.6-.7s-.6-.1-.5-.4h1l3-.1zM476.5 299.3c0-.3-.2-.8-.6-1-.3 0-.7 0-.5-.3l1-.1c.8 0 1.6-.2 2.4 0 1.2.2 2.3 1.2 2.6 2.3.2.8.3 1.6-.2 2.3-.5.6-1.4.8-2.2.8-.7 0-1.3 0-1.9.2-.2.1-.6-.1-.4-.4.3 0 .7-.1.6-.5l-.4-1.5-.4-1.8zm1.6 2.5c.1.3.2.7.4.9.3.2.7.1 1 0 .4 0 .8-.4.9-.9a4 4 0 0 0-.4-2.2 2 2 0 0 0-1.5-1.2 3 3 0 0 0-1.1 0c-.1 0 0 .2 0 .4l.7 3zM485.2 297.3c.3 0 .3.3.4.5l.2.9c-.2.2-.5 0-.5-.2-.1-.3-.3-.6-.6-.6h-1.3c-.2.1 0 .4 0 .6 0 .5.2 1 .3 1.4.3 0 .6 0 .8-.2.2-.2-.1-.6.2-.7.4 0 .3.5.4.7l.3 1.3c0 .3-.5 0-.5-.2 0-.3-.4-.5-.7-.4-.1 0-.5-.1-.3.1 0 .5.2 1 .4 1.6 0 .3.4.3.7.3.4 0 .9 0 1.2-.3.2-.2 0-.6.2-.8.2-.2.4.1.4.4 0 .3 0 .6.2 1-.1.2-.3.1-.5.1l-3 .2c-.3 0-.6.2-.9 0-.2-.2.1-.4.4-.4.3-.1.2-.5.1-.7l-.7-3.2c-.1-.3-.3-.7-.6-.7s-.6-.1-.5-.4h1l2.9-.3zM491.7 301.4c0 .3.3.6.6.7.2 0 .6 0 .7.2.1.3-.4.2-.6.2l-1.7.1c-.3 0-.6.1-.8 0-.3 0-.2-.4.1-.4.3 0 .6-.1.7-.4l-.1-.8-.7-2.8c0-.3-.3-.3-.6-.3-.2 0-.6.2-.7-.1 0-.4.5-.3.7-.4l1.1-.4c.2 0 .3.1.3.3l1 4.1zM495.4 298.1c0-.4-.3-.8-.7-.8-.3 0-.7 0-.8.3-.1.4 0 .8.4 1l.9.5.2-.6v-.4zm.8 2.9c0-.5-.6-.8-1-1-.2 0-.4-.2-.5-.1a1 1 0 0 0-.4 1c.2.6.5 1 1 1 .4.1.8 0 1-.4v-.5zm1-.2c0 .5-.2 1-.6 1.3-.5.4-1.3.4-2 .2-.6-.1-1-.6-1.2-1.2 0-.5.1-1 .5-1.4.1 0 .5-.1.2-.2-.5-.2-1-.6-1-1.2-.2-.5 0-1 .5-1.3a2 2 0 0 1 2.6.7c.2.4.2.9 0 1.2l-.6.5c.5 0 1 .4 1.2.8.2.1.3.4.3.6zM500.4 301.4c.2 0 .5-.2.5-.4.1-.2 0-.7.3-.6.3 0 .2.3.3.6 0 .4 0 .8-.4 1.1-.2.2-.5.1-.8.1h-1.7c-.2 0-.5.2-.7 0-.2-.2 0-.5 0-.7.2-.7.6-1.2 1-1.6.4-.3.8-.6.8-1.1 0-.4 0-.8-.2-1.2a1 1 0 0 0-1.4-.3c-.3.1-.5.5-.3.7.2.2.6 0 .7.4.2.2 0 .6-.3.6-.4 0-.8-.3-1-.7-.1-.5.1-1.1.6-1.4.5-.3 1.1-.3 1.7-.2.5.2 1 .6 1.2 1.2.1.4.1.9-.1 1.3-.4.7-1.2 1-1.7 1.7-.1.1-.2.3-.1.6 0-.3.4-.2.5-.2h1zM504.3 301c0 .2.3.5.6.6.2 0 .6 0 .7.2.2.3-.3.3-.5.3h-2.7c-.2-.1 0-.5.2-.4.3 0 .6-.1.7-.4v-.8l-.7-2.8c0-.3-.3-.3-.5-.3-.3 0-.6.2-.7 0-.2-.4.3-.4.5-.5l1.2-.4c.3 0 .3.1.4.3l.8 4.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#448127",
    stroke: "#34541f",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    stroke: "#4c0505",
    d: "M475.8 219.4 472 224c-1.2 5.2 1.8 9.2 7.7 12.6 4.7 3 13.5 3.7 16.3 1.3l-13.7-13-6.5-5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m503.6 354.3-2-2.5a100.8 100.8 0 0 1-32.7 28.6c15.1-4.2 25-15.2 34.7-26.1zM488.1 390a455.8 455.8 0 0 1 18.2-32.3l-2.1-2.7c-7.4 12.2-16 26.7-16 35zM529.9 275.5a62 62 0 0 0-4.3-13 126.6 126.6 0 0 0-43.8-44v-.3h.4l-.1-.1h.4l-.2-.3h.4l-.3-.4h.4l-.3-.3h.5l-.3-.4h.4l-.4-.3.6-.1-.5-.3.5-.1-.4-.3.6-.2-.5-.3.6-.3-.6-.4.7-.2-.8-.3.7-.4h-.8l.5-.7h-.7l.3-.5h-.6l.3-.5-.7.1.3-.6-.6.4.2-.7-.7.4.1-.7-.6.5.1-.7-.5.5v-.7l-.5.6v-.7l-.4.5-.2-.6-.4.6-.1-.7-.3.7-.2-.7-.3.7-.2-.6-.2.6-.2-.6-.2.8-.2-.7-.3.8-.3-.7v.8l-.4-.7v.8l-.5-.6v.8l-.4-.6v.7l-.4-.3.2.7-.5-.3.2.6-.4-.2.1.6h-.4l.2.4h-.3l.2.4a9 9 0 0 0-.4 3.5c0 .2.6.4.7.6.3.4.2.6.2.6-1.6 2.6-3 4.6-3.1 7.6 1.2-1.6 2.6-3.6 4.4-3.6-.9 1.5-1.3 6.1-.3 6.8l.8-1.3c0 1 .1 1.8.4 2.3.3-.6.6-1.3 1-1.7 0 1.5.2 2.7.6 3.3.5-.8 1-1.2 1.6-1.6-.2.9-.5 1.7-.3 2.7.6-1 1.2-1.7 1.9-2.5-.4 1.6 0 2.8.4 4.5.4-2 .6-2.3 1.5-3.1.1 1.9-.2 3.6.2 4.7.8-1.7 1.4-1.5 2-2.6-.2 1.6-.5 3.3 0 4.7a4.5 4.5 0 0 1 1.9-2.6c0 2.2.5 1.8-.8 3.7.6.2 2.5-.4 3.6-.9-.5 1.2-.4 2.1-.9 3 1-.6 2-1.5 2.9-2.4-.4 1.4-1.5 2.8-1 4.1.3-1.3 1.3-2.3 2.3-2.5-.2.7-.3 2.2-1.3 2.9 2.4.2 3.4-1.4 4.6-2.7-.1 1.3 0 2.4 1.6 4.3-.3-2.4.2-1.9 1.3-3.3.6 2.1 1.2 4.4 3.4 6-1-2.3-1-3.5-.6-4.9.3 1.5 1.7 3.3 2 4.6.3-1.5.5-3 1-4a20 20 0 0 1 1.4 5.6c.5-1 .9-2 1.1-3 19.8 20.5 24.2 46.7 2.5 74.4 7.8-5.2 9.8-13.5 14.1-20.6-4.2 9.3-6 19.7-13.5 27.4 7.2-6.2 8.7-11.9 13-17.9-4.5 12.5-11 26.2-19.8 38.8l4.8 5.2 4-6.9c9.4-15.4 24.7-37.5 17-71.1z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#eac102",
    stroke: "#a08307",
    strokeWidth: 0.2,
    d: "M473.2 215.3c-1 .2-1.4.6-2.2 1.4 1 .2 1.7.3 2.6.3.2 0 .3-.4.3-.6l-.2-1c0-.2-.6-.1-.8 0l.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a08307",
    d: "M471 216.7a9.9 9.9 0 0 1 2.2-.5 9.8 9.8 0 0 1-2.2.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 477.7,
    cy: 215.4,
    r: 0.8,
    stroke: "#000",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 477.9,
    cy: 215.3,
    fill: "url(#o)",
    rx: 0.3,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#34541f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M488.2 389.7a83.4 83.4 0 0 1 7.4-17.2 199.6 199.6 0 0 1 7.1-12.2l2.6-4-2.5 4a407 407 0 0 0-7 12.3 133.7 133.7 0 0 0-7.6 17zM469.3 380.2a75.8 75.8 0 0 0 29.7-23.1 153.5 153.5 0 0 0-11.2 11.8 70 70 0 0 1-18.5 11.3zM506.6 350.9c.8-1 1.5-2.2 2.2-3.3a136.2 136.2 0 0 0 6-10.2c1.4-2.3 2.6-4.7 3.8-7l3.7-7-1.7 3.5-1.8 3.6a256 256 0 0 1-7.7 13.8 93.8 93.8 0 0 1-4.5 6.6zM512.5 325.8a58.4 58.4 0 0 0 8.5-13.4 72.6 72.6 0 0 0 6-23 54.2 54.2 0 0 0-.1 4 58.8 58.8 0 0 1-5.8 19 59.9 59.9 0 0 1-8.6 13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.9 320a52 52 0 0 0 8.7-12.5A96 96 0 0 0 524 297l.3-.9.3-.9.6-1.8a41.6 41.6 0 0 0 .2-15.4 58 58 0 0 0 .7 7.7c0 2.6-.2 5.2-.7 7.7-.3.6-.4 1.3-.6 1.9l-.3.9-.4.9a229 229 0 0 1-4.4 10.6 51.6 51.6 0 0 1-3.8 6.6 36 36 0 0 1-5 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505 349.2c1.3-1.6 2.4-3.3 3.6-5l1.8-2.5 1.7-2.5 3-5.4 2.6-5.5c1.8-3.7 3.5-7.4 5-11.3a78.8 78.8 0 0 0 5.3-23.8 58.4 58.4 0 0 0-2.6-24.2 52.4 52.4 0 0 1 2.8 24.2 80 80 0 0 1-5.3 23.9c-1.5 3.8-3.2 7.5-5 11.2l-2.8 5.5c-.9 1.9-1.8 3.7-2.9 5.4-.5 1-1.1 1.7-1.7 2.6l-1.8 2.5-3.6 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.8 352.3a443.4 443.4 0 0 0 13.4-23.5 81.9 81.9 0 0 0 8.7-39.2c0-4.5-.4-9-1.2-13.4a57.6 57.6 0 0 0 .1 0c.9 4.4 1.2 9 1.2 13.4a102.9 102.9 0 0 1-3.6 26.7 82 82 0 0 1-5 12.6 442.6 442.6 0 0 1-13.5 23.4zM480 220.8h1.4a14.3 14.3 0 0 1 4.1 1.3 35.8 35.8 0 0 1 9 6.8 37.8 37.8 0 0 0-9-6.6 19 19 0 0 0-5.5-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#448127"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M496.4 231.6s3 1.8 4.7 4.4c0 0-4.7-.9-8-4.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34541f",
    d: "M496.4 231.6a14.4 14.4 0 0 1 4.8 4.4l.1.2h-.2a14.5 14.5 0 0 1-4.4-1.8c-1.4-.8-2.6-1.8-3.7-3a15.2 15.2 0 0 0 5.9 3.8l2.2.7v.2a11.1 11.1 0 0 0-2.2-2.5 17.7 17.7 0 0 0-2.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.6 230.7s7.2 4.6 8.3 5c0 0-1.7-3.5-5.1-5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34541f",
    d: "m489.6 230.7 4.1 2.5a156.9 156.9 0 0 0 3.1 1.8l1 .6v.1a10.7 10.7 0 0 0-2.1-2.9 10.7 10.7 0 0 0-2.9-2.1 8.4 8.4 0 0 1 3 2 11 11 0 0 1 2.1 3l.2.2-.3-.1-2.1-1.2a153.5 153.5 0 0 1-6.1-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.5 228.4s3.7 1.6 4.6 4.3c0 0-6.8-2.8-8-4.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34541f",
    d: "M492.5 228.4a10.7 10.7 0 0 1 2.8 1.6l1.1 1.2.8 1.5v.2h-.2a77.2 77.2 0 0 1-7-3.7l-.9-.8.9.7 1 .6a36 36 0 0 0 6.1 3h-.1c-.2-.4-.4-1-.8-1.3a4 4 0 0 0-1-1.2 10.8 10.8 0 0 0-2.7-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.8 231.3s6.6 4.7 8.6 4.7c0 0-2-3.3-5.4-4.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34541f",
    d: "M486.8 231.3a124 124 0 0 0 7.4 4.3l1.2.3-.1.2a12.4 12.4 0 0 0-2.3-2.8 13 13 0 0 0-3-2 10.7 10.7 0 0 1 4.4 3.2l1 1.5.2.1h-.2c-.5 0-.9-.1-1.3-.3l-1-.5a33.3 33.3 0 0 1-6.3-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.8 232.7s3.4 3 5.4 3c0 0-2-3.3-5.4-4.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34541f",
    d: "M486.8 232.7a32 32 0 0 0 4 2.5l.6.2.8.2-.1.1a12.4 12.4 0 0 0-2.3-2.7 13 13 0 0 0-3-2 10.7 10.7 0 0 1 4.4 3.1l1 1.5.2.2h-.2a4 4 0 0 1-1.6-.4 11.5 11.5 0 0 1-2.6-1.7 4 4 0 0 1-1.2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485 226.2s7.2 5.1 8 7.9c0 0-6.4-3-7.6-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34541f",
    d: "M485 226.2a51.6 51.6 0 0 1 7.5 6.6l.7 1.2v.3l-.2-.1a79.6 79.6 0 0 1-6.8-3.9l-.8-.7.8.7 1 .6a37.3 37.3 0 0 0 6 3l-.2.2-.7-1.2a29.3 29.3 0 0 0-5-5l-2.3-1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#24420e",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M445 370.3a42.2 42.2 0 0 1-20.4 4.8c10-8.2 19.7-8.4 20.4-4.8zM514.8 374.8c5.2 4.7 21 8 23.5 7.4-10.6-10.7-22.1-11.8-23.5-7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M445 370.3c-.7-3.7-10.5-3.4-20.4 4.8a69.6 69.6 0 0 1 20.4-4.8zM514.9 374.7c1.4-4.4 12.8-3.3 23.4 7.5a84 84 0 0 0-23.4-7.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGt);
export default __webpack_public_path__ + "static/media/gt.854277c2db5540ea978c762cfaf495c3.svg";
export { ForwardRef as ReactComponent };